import React from 'react'
import { Loader, Dimmer } from 'semantic-ui-react'
import { useFileUrl } from './helpers'

const ImagePreview = ({ previewProps }) => {
  const { url } = useFileUrl(previewProps.FileID, previewProps.HashSum_FileID_)

  return url ? (
    <img src={url} alt="ImgFile" className="file-preview__image" />
  ) : (
    <Dimmer active inverted>
      <Loader />
    </Dimmer>
  )
}

export default ImagePreview
